import { defineCopy } from './index';

export const shellCopy = defineCopy('shell', {
  appName: 'TTS Basketball',
  tabs: {
    home: 'Home',
    stats: 'Stats',
    play: 'Play',
    crew: 'Crew',
    me: 'Me',
  },
  header: {
    home: 'Back to Home',
  },
  update: {
    title: 'New version on the bench.',
    action: 'Sub it in',
    later: 'Later',
    working: 'Subbing in...',
    downloading: 'Downloading the update...',
    required: 'This version is too old for the server. Update to keep playing.',
    requiredTitle: 'Time to update.',
    requiredAction: 'Update now',
    plays: '{n} plays are saved on this phone. They go up after the update.',
    playsOne: '1 play is saved on this phone. It goes up after the update.',
    stalled: 'The download is still running. Keep the app open and tap Update now again in a minute.',
    stuck: 'Still on the old version. Close the app, open it again, and tap Update now.',
    dot: 'Update waiting. It starts when you are off the book.',
  },
  offline: "No signal. Scores are saved on this phone and sync when you're back.",
  loading: 'Lacing up...',
  splash: 'Warming up',
  notFound: {
    title: 'Airball.',
    body: "That page isn't on this court.",
    action: 'Back to Home',
  },
  routeError: {
    title: 'Something broke on our end.',
    body: 'Your game is safe. Try again in a sec.',
    action: 'Reload',
  },
});
